module.exports = __webpack_public_path__ + "static/media/empty_video_img_insta.78a667c5.svg";